export const categories = [
  {
    slug: "zonghe",
    name: "综合平台",
    icon: "ri-global-line",
    description: "涵盖电影、电视剧、综艺、动漫等全品类内容的综合视频平台，一站式满足各种观影需求。",
  },
  {
    slug: "dianying",
    name: "电影专区",
    icon: "ri-film-line",
    description: "专注于提供高质量电影资源的平台，包括国内外大片、经典老片和独立电影等。",
  },
  {
    slug: "dianshiju",
    name: "电视剧集",
    icon: "ri-tv-line",
    description: "拥有丰富电视剧资源的视频平台，涵盖国产剧、美剧、韩剧等多种类型剧集。",
  },
  {
    slug: "zongyi",
    name: "综艺娱乐",
    icon: "ri-emotion-laugh-line",
    description: "以综艺节目和娱乐内容为主的平台，提供音乐、真人秀、脱口秀等多样化综艺。",
  },
  {
    slug: "jilupian",
    name: "纪录片库",
    icon: "ri-camera-lens-line",
    description: "集中提供优质纪录片内容的平台，涵盖自然、历史、人文、科技等多个知识领域。",
  },
  {
    slug: "duanshipin",
    name: "短视频追剧",
    icon: "ri-smartphone-line",
    description: "通过短视频形式追剧看片，适合碎片时间观影，短剧和影视解说内容为主。",
  },
];